import type { FormFieldOptions } from "@tellescope/types-models";

/**
 * Ensures `optionDetails` is always populated for fields that use choices-based rendering.
 *
 * The API may store choices as a plain `choices: string[]` without the richer
 * `optionDetails: FormFieldOptionDetails[]` array that field components (e.g. MultipleChoiceField,
 * DropdownField) read from. When `optionDetails` is absent but `choices` is present, this
 * function derives `optionDetails` from `choices` so components render correctly.
 */
export const normalizeFieldOptions = (options: FormFieldOptions | undefined): FormFieldOptions | undefined => {
  if (!options) return options;
  if (options.optionDetails?.length) return options;
  if (!options.choices?.length) return options;
  return {
    ...options,
    optionDetails: options.choices.map((choice) => ({ option: choice })),
  };
};
